// Where every "Log in" CTA points. Override with VITE_APP_URL (e.g.
// http://localhost:5173) in www/.env.local for local dev.
export const APP_URL = import.meta.env.VITE_APP_URL ?? 'https://app.teslergarage.com';
